import { apiRequest, buildQuery } from "./api-client";

export const adminService = {
    dashboard() {
        return apiRequest("/admin/dashboard");
    },
    analytics() {
        return apiRequest("/admin/analytics");
    },
    jobs(params = {}) {
        return apiRequest(`/admin/jobs${buildQuery(params)}`);
    },
    jobViews(jobId) {
        return apiRequest(`/admin/jobs/${jobId}/views`);
    },
    updateJob(jobId, payload) {
        return apiRequest(`/admin/jobs/${jobId}`, { method: "PATCH", body: payload });
    },
    approveJob(jobId, payload = {}) {
        return apiRequest(`/admin/jobs/${jobId}/approve`, { method: "POST", body: payload });
    },
    rejectJob(jobId, payload = {}) {
        return apiRequest(`/admin/jobs/${jobId}/reject`, { method: "POST", body: payload });
    },
    requestJobChanges(jobId, payload = {}) {
        return apiRequest(`/admin/jobs/${jobId}/request-changes`, { method: "POST", body: payload });
    },
    closeJob(jobId, payload = {}) {
        return apiRequest(`/admin/jobs/${jobId}/close`, { method: "POST", body: payload });
    },
    users(params = {}) {
        return apiRequest(`/admin/users${buildQuery(params)}`);
    },
    createUser(payload) {
        return apiRequest("/admin/users", { method: "POST", body: payload });
    },
    updateUser(userId, payload) {
        return apiRequest(`/admin/users/${userId}`, { method: "PATCH", body: payload });
    },
    impersonateUser(userId) {
        return apiRequest(`/admin/users/${userId}/impersonate`, { method: "POST" });
    },
    updateUserStatus(userId, status) {
        return this.updateUser(userId, { status });
    },
    resetUserPassword(userId, password) {
        return this.updateUser(userId, { password });
    },
    companies(params = {}) {
        return apiRequest(`/admin/companies${buildQuery(params)}`);
    },
    createCompany(payload) {
        return apiRequest("/admin/companies", { method: "POST", body: payload });
    },
    updateCompany(companyId, payload) {
        return apiRequest(`/admin/companies/${companyId}`, { method: "PATCH", body: payload });
    },
    verifyCompany(companyId, verified = true) {
        return apiRequest(`/admin/companies/${companyId}/verification`, { method: "PATCH", body: { verified } });
    },
    uploadCompanyLogo(companyId, file) {
        return uploadFile(`/admin/companies/${companyId}/logo`, file);
    },
    uploadCompanyBanner(companyId, file) {
        return uploadFile(`/admin/companies/${companyId}/banner`, file);
    },
    applications(params = {}) {
        return apiRequest(`/admin/applications${buildQuery(params)}`);
    },
    resumes(params = {}) {
        return apiRequest(`/admin/resumes${buildQuery(params)}`);
    },
    media(params = {}) {
        return apiRequest(`/admin/media${buildQuery(params)}`);
    },
    cleanupMedia() {
        return apiRequest("/admin/media/cleanup-orphans", { method: "POST" });
    },
    settings(group) {
        return apiRequest(group ? `/admin/settings/${group}` : "/admin/settings");
    },
    updateSettings(group, payload) {
        return apiRequest(`/admin/settings/${group}`, { method: "PATCH", body: payload });
    },
    siteContent() {
        return apiRequest("/admin/site-content");
    },
    updateSiteContent(blockKey, payload) {
        return apiRequest(`/admin/site-content/${blockKey}`, { method: "PATCH", body: payload });
    },
    featureFlags() {
        return apiRequest("/admin/feature-flags");
    },
    updateFeatureFlag(key, enabled) {
        return apiRequest(`/admin/feature-flags/${key}`, { method: "PATCH", body: { enabled } });
    },
    auditLogs(params = {}) {
        return apiRequest(`/admin/audit-logs${buildQuery(params)}`);
    },
    globalSearch(keyword) {
        return apiRequest(`/admin/global-search${buildQuery({ keyword })}`);
    },
    updateDatabaseCategories() {
        return apiRequest("/admin/update-database-categories", { method: "POST" });
    }
};

function uploadFile(path, file) {
    const formData = new FormData();
    formData.set("file", file);
    return apiRequest(path, {
        method: "POST",
        body: formData
    });
}
